<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncSellers()"
      v-if="!loading"
    >
      Sync Sellers
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Email</th>
        <th>Name</th>
        <th>Cedula Rif</th>
        <th>Departament ID</th>
        <th>Departament Name</th>
        <th>Cia ID</th>
        <th>Vendedor ID</th>
      </thead>
      <tbody>
        <tr v-for="seller in sellers" :key="seller.id">
          <td>{{ seller.id }}</td>
          <td>{{ seller.email }}</td>
          <td>{{ seller.name }}</td>
          <td>{{ seller.cedulaRif }}</td>
          <td>{{ seller.departmentId }}</td>
          <td>{{ seller.departmentName }}</td>
          <td>{{ seller.ciaId }}</td>
          <td>{{ seller.vendedorId }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getSellers, getSyncSellers } from "@/api/Infoauto.js";
export default {
  name: "Sellers",
  data() {
    return {
      sellers: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.sellers = await getSellers();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncSellers() {
      this.loading = true;
      try {
        this.sellers = await getSyncSellers();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
